
// winOnresize
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import homeModal from "./home-modal.vue";
import { State } from "vuex-class";
import maxNumber from "@/components/max-number/max-number.vue";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-home-modal": homeModal,
    "pi-max-number": maxNumber
  }
})
export default class PiHomeTodayItem extends Vue {
  @Prop({
    default: () => {
      return {};
    }
  })
  private formData!: objAny;
  @State("sys") sys!: objAny;
  @Watch("sys.winOnresize")
  getVisible() {
    this.resizeBox();
  }
  @Watch("data.list")
  getFromData() {
    this.init();
  }
  @Prop({
    default: () => {
      return {};
    }
  })
  private data!: objAny;
  private myChart: objAny = {};
  private chargeEchart: objAny = {};
  private homeModal: objAny = {};
  private win: objAny = window;

  public resizeBox(): void {
    if (this.myChart.id) {
      this.myChart.resize();
    }
  }
  public init() {
    const nameArr: string[] = [];
    this.data.list.map((item: objAny) => {
      nameArr.push(item.name);
    });
    // const that = this;
    const option: objAny = {
      title: {
        zlevel: 0,
        text: [
          "{name|" + i18n.t("home.total") + "}",
          "{value|" + this.data.total + "}"
        ].join("\n"),
        rich: {
          value: {
            color: "#ffffff",
            fontSize: 20,
            fontWeight: "bold",
            lineHeight: 28
          },
          name: {
            color: "#909399",
            lineHeight: 20,
            fontSize: 14
          }
        },
        top: "center",
        left: "20.6%",
        textAlign: "center",
        textStyle: {
          rich: {
            value: {
              color: "#333",
              fontSize: 20,
              fontWeight: "bold",
              lineHeight: 28,
              marginTop: 5
            },
            name: {
              color: "#666666",
              lineHeight: 20
            }
          }
        }
      },
      legend: {
        // type: "scroll",
        // orient: "vertical",
        left: "50%",
        y: "center",
        icon: "circle",
        itemWidth: 12, // 设置宽度
        itemHeight: 12, // 设置高度
        // itemGap: 20,
        data: nameArr,
        formatter: (name: string) => {
          const i: number = nameArr.indexOf(name);
          const text: string = name + ": " + this.data.list[i].value;
          if (nameArr.length < 4) {
            return text;
          } else {
            return ["{a|" + text + "}"].join("\n");
          }
        }
      },
      tooltip: {
        trigger: "item",
        formatter: "{a} <br/>{b}: {c} ({d}%)"
      },
      color: this.data.color,
      series: [
        {
          name: this.data.title,
          type: "pie",
          radius: ["65%", "90%"],
          center: ["22%", "50%"],

          avoidLabelOverlap: false,
          label: {
            show: false,
            position: "center"
          },
          emphasis: {
            label: {
              show: false
            }
          },
          labelLine: {
            show: false
          },
          data: this.data.list
        }
      ]
    };
    if (nameArr.length < 4) {
      option.legend.orient = "vertical";
    } else {
      let width = 55;
      let left = "45%";
      const doc: objAny = document;
      if (doc.body.clientWidth > 1600) {
        width = 70;
        left = "50%";
      }
      // option.legend.formatter = ["{a|{name}}"].join("\n");
      option.legend.textStyle = {
        rich: {
          a: {
            width: width
          }
        }
      };
      option.legend.left = left;
    }
    this.myChart = this.win.echarts.init(this.chargeEchart);
    this.myChart.clear();
    this.myChart.setOption(option, true);
  }
  public getBai(total: number, value: number): string {
    if (total > 0) {
      let t: string = ((value / total) * 100).toFixed(2);
      if (parseFloat(t) > 100) {
        t = 100 + "";
      }
      return t + "%";
    } else {
      return "";
    }
  }
  public openHomeToday(): void {
    const formData = Object.assign(this.formData, { aim: this.data.aim });

    this.homeModal.open({
      title: this.data.title,
      formData: formData
    });
  }
  mounted() {
    this.$nextTick(() => {
      this.chargeEchart = this.$refs["chargeEchart"];
      this.homeModal = this.$refs["homeModal"];
    });
  }
}
